import { render, staticRenderFns } from "./publishContent.vue?vue&type=template&id=25d60810&scoped=true&"
import script from "./publishContent.vue?vue&type=script&lang=js&"
export * from "./publishContent.vue?vue&type=script&lang=js&"
import style0 from "./publishContent.vue?vue&type=style&index=0&id=25d60810&lang=scss&scoped=true&"
import style1 from "./publishContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d60810",
  null
  
)

export default component.exports